import { render } from "./DadosFinanceiros.vue?vue&type=template&id=2fdfec44"
import script from "./DadosFinanceiros.vue?vue&type=script&lang=js"
export * from "./DadosFinanceiros.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__